(function () {
  'use strict';
  var bar = document.getElementById('rm-ann-bar');
  var textEl = document.getElementById('rm-ann-bar-text');
  if (!bar || !textEl) return;

  var interval = parseInt(bar.getAttribute('data-interval') || '4', 10) * 1000;
  var msgs = [
    bar.getAttribute('data-msg-1'),
    bar.getAttribute('data-msg-2'),
    bar.getAttribute('data-msg-3'),
    bar.getAttribute('data-msg-4')
  ].filter(Boolean);

  if (!msgs.length) return;

  var idx = 0;

  function pad(n) { return String(n).padStart(2, '0'); }

  function countdownStr() {
    var end = new Date();
    end.setHours(23, 59, 59, 999);
    var diff = Math.max(0, Math.floor((end.getTime() - Date.now()) / 1000));
    return pad(Math.floor(diff / 3600)) + ':' + pad(Math.floor((diff % 3600) / 60)) + ':' + pad(diff % 60);
  }

  function render() {
    var i = idx % msgs.length;
    var msg = msgs[i];
    if (i === 2 || (msg && msg.indexOf('Summer deals') === 0)) {
      textEl.textContent = 'Summer deals eindigen over ' + countdownStr();
    } else {
      textEl.textContent = msg;
    }
    textEl.style.animation = 'none';
    void textEl.offsetWidth;
    textEl.style.animation = 'rmBarFade 0.5s ease';
    idx++;
  }

  render();
  setInterval(render, interval);
  setInterval(function () {
    var i = (idx - 1 + msgs.length) % msgs.length;
    if (i === 2 || (msgs[i] && msgs[i].indexOf('Summer deals') === 0)) {
      textEl.textContent = 'Summer deals eindigen over ' + countdownStr();
    }
  }, 1000);
})();
